var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-time-picker" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.mutableValue,
          expression: "mutableValue",
        },
      ],
      ref: "timePicker",
      attrs: { type: "hidden" },
      domProps: { value: _vm.mutableValue },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.mutableValue = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "inputContainer",
        staticClass: "input-container",
        on: { click: _vm.togglePopup },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedHour,
              expression: "selectedHour",
            },
          ],
          staticClass: "time-input",
          domProps: { value: _vm.selectedHour },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.selectedHour = $event.target.value
              },
              _vm.handleHourInput,
            ],
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(":")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedMinute,
              expression: "selectedMinute",
            },
          ],
          staticClass: "time-input",
          domProps: { value: _vm.selectedMinute },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.selectedMinute = $event.target.value
              },
              _vm.manualUpdateTime,
            ],
          },
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "period-input",
          domProps: { value: _vm.selectedPeriodLabel },
          on: { input: _vm.handlePeriodInput },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "date-icon-field", on: { click: _vm.togglePopup } },
          [
            _c("img", {
              staticClass: "date-picker-icon",
              attrs: { src: "/images/svgs/clock.svg", alt: "" },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["time-picker-popup", { "d-none": !_vm.showPopup }],
        attrs: { "click.stop": "" },
      },
      [
        _c("div", { staticClass: "scroll-container" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "time-picker-select-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.incrementHour.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/svgs/search-arrow-up.svg"
                    ),
                    alt: "Up Arrow",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedHour,
                    expression: "selectedHour",
                  },
                ],
                staticClass: "time-picker-select border-0",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedHour = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.hours, function (hour) {
                return _c("option", { key: hour, domProps: { value: hour } }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(hour) +
                      "\n                    "
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "time-picker-select-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.decrementHour.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/svgs/search-arrow-down.svg"
                    ),
                    alt: "Up Arrow",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(":")]),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "time-picker-select-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.incrementMinute.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/svgs/search-arrow-up.svg"
                    ),
                    alt: "Up Arrow",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedMinute,
                    expression: "selectedMinute",
                  },
                ],
                staticClass: "time-picker-select border-0",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedMinute = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.minutes, function (minute) {
                return _c(
                  "option",
                  { key: minute, domProps: { value: minute } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(minute) +
                        "\n                    "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "time-picker-select-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.decrementMinute.apply(null, arguments)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.brandingImagesPath(
                      "/images/svgs/search-arrow-down.svg"
                    ),
                    alt: "Up Arrow",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedPeriod,
                  expression: "selectedPeriod",
                },
              ],
              staticClass: "time-picker-select period-select border-0",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedPeriod = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "AM" } }, [
                _vm._v(_vm._s(_vm.periodLabels.AM)),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "PM" } }, [
                _vm._v(_vm._s(_vm.periodLabels.PM)),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }